import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDelivery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M16.489 16.329H9.77m10.809 0h1.426v-4.33l-3.572-3.69h-2.922v7.98m6.494-4.29h-6.494m-9.135 2.824a1.949 1.949 0 1 1 2.756 2.756 1.949 1.949 0 0 1-2.756-2.756Z"
      transform="scale(2)"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M17.238 14.823a1.949 1.949 0 1 1 2.756 2.756 1.949 1.949 0 0 1-2.756-2.756ZM3.966 5v11.322h1.758"
      transform="scale(2)"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M15.53 8.314V5H3.965m4.32 0h-4.32m4.321 2.49H2.872m4.957 2.492H2"
      transform="scale(2)"
    />
  </svg>
);
export default SvgDelivery;
